import Assistant from '@curity/oauth-assistant';
import { resolveEnvironment } from '../EnvironmentResolver';

/* istanbul ignore next */
const checkSessionIframeEvents = {
    onStateChanging: () => {
        return 'On State Changing'
    },
    onStateChanged: () => {
        return 'On State Changed'
    },
    onLogout: () => {
        return 'On Logout Change'
    },
    onConsent: () => {
        return 'On Consent'
    },
    onError: () => {
        return 'On Error'
    },
    onUnchanged: () => {
        return 'On Unchanged'
    },
}

const {
    ALLOWED_ASSISTANT_ORIGIN: assistantOrigin,
    ALLOWED_SITE_ORIGIN: siteOrigin,
    AUTH_URL: authBaseUrl
} = resolveEnvironment();

const authIssuer = authBaseUrl + '/oauth/v2/oauth-anonymous'
const allowedOrigins = [assistantOrigin, siteOrigin, 'https://docker-curity-master.dev.service.arionbanki.is']

// See https://www.npmjs.com/package/@curity/oauth-assistant#settings
const authorizeSettings: any = {
    base_url: authBaseUrl,
    client_id: "openbanking-webportal-ui-client",
    issuer: authIssuer,
    redirect_uri: globalThis.origin,
    for_origin: globalThis.origin,
    flow_type: "code",
    iframe: {
        targetElement: 'body',
        width: null, // take default value
        height: null, // take default value
        backdrop: {
            visible: true, // default is true
            style: null, // take default value
            backdropClass: "backdrop-class"
        }
    },
    allowed_origins: allowedOrigins, // default is [window.origin]
    check_session_iframe: undefined,
    session_polling_interval: 5, // polling interval in seconds, default is 5
    allowed_jwt_algorithms: ['RS256'],
    jwt_sig_public_key: { // allowed formats are jwk | jwks_uri | pem | issuer | metadata_url | raw
        format: 'issuer', // in case of issuer, the issuer value will be taken from jwt payload
        value: null
    },
    debug: false,
    // openid_configuration_url: "" // Set if the OpenID Configuration URL uses different host or base path than the issuer
    check_session_iframe_events: checkSessionIframeEvents,
    clock_tolerance: 150
};

const mockAssistant = {
    getToken: () => {return 'mock token'}
}

/**
 * Create an OAuth assistant 
 * @param customSettings Any settings that you want to change from {@link authorizeSettings}
 * @returns a loaded OAuth Assistant
 */
/* istanbul ignore next */
export const createAssistant = (customSettings: any = null) => {
    const settings: Assistant.Settings = { ...authorizeSettings, ...customSettings };
    const assistant = new Assistant(settings);
    assistant.init()
        .then(() => {
            console.log("Assistant loaded");
        });
    return assistant;
}

/* istanbul ignore next */
export const createMockAssistant = () => mockAssistant;